var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "element-transform-wrapper" }, [
    _c("section", [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("h6", [_vm._v("Dimensions")]),
          _vm._v(" "),
          _c(_setup.CButton, {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            staticClass: "ml-auto mr-1",
            attrs: {
              content: "Copy Dimensions",
              size: "icon",
              icon: ["far", "copy"],
              disabled: !_setup.supportsCopyPaste,
            },
            on: { click: _setup.onCopyDimensions },
          }),
          _vm._v(" "),
          _c(_setup.CButton, {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            attrs: {
              content: "Paste Dimensions",
              size: "icon",
              icon: ["far", "paste"],
              disabled: !_setup.canPasteDimensions,
            },
            on: { click: _setup.onPasteDimensions },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              value: _setup.model.width,
              label: `Width (${_vm.units})`,
              name: "width",
              type: "decimal",
              placeholder: _setup.placeholderFor(_setup.model.width),
              min: 1,
              max: 9999999,
              disabled: _setup.disabled.common,
            },
            on: { input: _setup.updateWidth },
          }),
          _vm._v(" "),
          _vm.linkedRatio
            ? _c("font-awesome-icon", {
                staticClass: "mt-3",
                attrs: { icon: ["far", "link"] },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              value: _setup.model.height,
              label: `Height (${_vm.units})`,
              type: "decimal",
              name: "height",
              placeholder: _setup.placeholderFor(_setup.model.height),
              min: 1,
              max: 9999999,
              disabled: _setup.disabled.common,
            },
            on: { input: _setup.updateHeight },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("h6", [_vm._v("Position")]),
          _vm._v(" "),
          _c(_setup.CButton, {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            staticClass: "ml-auto mr-1",
            attrs: {
              content: "Copy Position",
              size: "icon",
              icon: ["far", "copy"],
              disabled: !_setup.supportsCopyPaste,
            },
            on: { click: _setup.onCopyPosition },
          }),
          _vm._v(" "),
          _c(_setup.CButton, {
            directives: [{ name: "tippy", rawName: "v-tippy" }],
            attrs: {
              content: "Paste Position",
              size: "icon",
              icon: ["far", "paste"],
              disabled: !_setup.canPastePosition,
            },
            on: { click: _setup.onPastePosition },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              value: _setup.model.centerX,
              label: `Position x (${_vm.units})`,
              type: "decimal",
              name: "centerX",
              placeholder: _setup.placeholderFor(_setup.model.centerX),
              min: -9999999,
              max: 9999999,
              disabled: _setup.disabled.common,
            },
            on: { input: _setup.updateCenterX },
          }),
          _vm._v(" "),
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              value: _setup.model.centerY,
              label: `Position y (${_vm.units})`,
              type: "decimal",
              name: "centerY",
              placeholder: _setup.placeholderFor(_setup.model.centerY),
              min: -9999999,
              max: 9999999,
              disabled: _setup.disabled.common,
            },
            on: { input: _setup.updateCenterY },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              value: _setup.model.rotation,
              label: "Rotation (dg)",
              type: "decimal",
              name: "rotation",
              placeholder: _setup.placeholderFor(_setup.model.rotation),
              min: -360,
              max: 360,
              disabled: _setup.disabled.common,
            },
            on: { input: _setup.updateRotation },
          }),
          _vm._v(" "),
          _setup.showSkew
            ? [
                _c(_setup.CInput, {
                  staticClass: "flex-fill",
                  attrs: {
                    value: _setup.model.skewX,
                    label: "Skew Horizontal (dg)",
                    type: "decimal",
                    name: "skewx",
                    placeholder: _setup.placeholderFor(_setup.model.skewX),
                    min: -80,
                    max: 80,
                    disabled: _setup.disabled.common,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.updateSkew("x", $event)
                    },
                  },
                }),
                _vm._v(" "),
                _c(_setup.CInput, {
                  staticClass: "flex-fill",
                  attrs: {
                    value: _setup.model.skewY,
                    label: "Skew vertical (dg)",
                    type: "decimal",
                    name: "skewy",
                    placeholder: _setup.placeholderFor(_setup.model.skewY),
                    min: -80,
                    max: 80,
                    disabled: _setup.disabled.common,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.updateSkew("y", $event)
                    },
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "flex-row" },
      [
        _c("div", [
          _c("label", { staticClass: "m-0" }, [_vm._v("Arrange Layers")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-container" },
            [
              _c(_setup.CButton, {
                directives: [{ name: "tippy", rawName: "v-tippy" }],
                attrs: {
                  content: "Bring to front",
                  size: "icon",
                  icon: ["far", "bring-front"],
                  disabled: _setup.disabled.arrange,
                },
                on: {
                  click: function ($event) {
                    return _setup.arrangeElement("front")
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CButton, {
                directives: [{ name: "tippy", rawName: "v-tippy" }],
                attrs: {
                  content: "Bring forward",
                  size: "icon",
                  icon: ["far", "bring-forward"],
                  disabled: _setup.disabled.arrange,
                },
                on: {
                  click: function ($event) {
                    return _setup.arrangeElement("forward")
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CButton, {
                directives: [{ name: "tippy", rawName: "v-tippy" }],
                attrs: {
                  content: "Send backward",
                  size: "icon",
                  icon: ["far", "send-backward"],
                  disabled: _setup.disabled.arrange,
                },
                on: {
                  click: function ($event) {
                    return _setup.arrangeElement("backward")
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CButton, {
                directives: [{ name: "tippy", rawName: "v-tippy" }],
                attrs: {
                  content: "Send to back",
                  size: "icon",
                  icon: ["far", "send-back"],
                  disabled: _setup.disabled.arrange,
                },
                on: {
                  click: function ($event) {
                    return _setup.arrangeElement("back")
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _setup.showFlip
          ? [
              _c("div", { staticClass: "border-left" }),
              _vm._v(" "),
              _c("div", [
                _c("label", { staticClass: "m-0" }, [_vm._v("Flip")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-container" },
                  [
                    _c(_setup.CButton, {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      attrs: {
                        content: "Flip Horizontal",
                        size: "icon",
                        icon: ["far", "reflect-horizontal"],
                        disabled: _setup.disabled.flip,
                      },
                      on: {
                        click: function ($event) {
                          _setup.flipElement("x")
                          _setup.recordFeatureUsage(
                            _setup.TrackedFeature.FlipHorizontal
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(_setup.CButton, {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      attrs: {
                        content: "Flip Vertial",
                        size: "icon",
                        icon: ["far", "reflect-vertical"],
                        disabled: _setup.disabled.flip,
                      },
                      on: {
                        click: function ($event) {
                          _setup.flipElement("y")
                          _setup.recordFeatureUsage(
                            _setup.TrackedFeature.FlipVertical
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _setup.showPerspective
          ? _c(
              "div",
              { staticClass: "align-self-end" },
              [
                _c(_setup.CButton, {
                  attrs: {
                    text: "Perspective",
                    variant: _setup.model.perspectiveActive
                      ? "outline-primary"
                      : "light",
                    icon: ["fak", "perspective"],
                    disabled: _setup.model.hasInitWidth,
                  },
                  on: { click: _setup.togglePerspective },
                }),
                _vm._v(" "),
                _setup.model.perspectiveEnabled
                  ? _c(_setup.CButton, {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      staticClass: "ml-2",
                      attrs: {
                        content: "Reset perspective",
                        variant: "light",
                        size: "icon",
                        icon: ["fas", "rotate-left"],
                      },
                      on: { click: _setup.resetPerspective },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }